<template>
    <div>
        <url-input 
            placeholder="Введите url-адрес"
            :val="url"
            :autofocus="true"
            @change="updateURL"
        />
        <div class="dg-clear" />
        <hr>
            <div>
                UTM метки можно добавить в URL вручную.<br>
                В URL будут автоматически добавлены следующие UTM метки:<br>
                <code>
                    <span v-if="utm_medium && (!url.includes('utm_medium=')) ">
                        utm_medium=<strong>{{ utm_medium }}</strong> &amp;
                    </span>
                    <span v-if="utm_source && !url.includes('utm_source=')">
                        utm_source=<strong>{{ utm_source }}</strong> &amp;
                    </span>
                    <span v-if="utm_campaign && !url.includes('utm_campaign=')">
                        utm_campaign=<strong>{{ utm_campaign }}</strong>
                    </span>
                    <span v-if="utm_content && !url.includes('utm_content=')">
                        utm_content=<strong>{{ utm_content }}</strong>
                    </span>
                </code>
                <br>
            </div>
            <div class="invalid-feedback d-block">
                {{ urlError }}&nbsp;
            </div>
        <hr>
        <button
            class="dg-btn dg-btn--cancel"
            @click.stop.prevent="handleDismiss()"
        >
            <span>Отмена</span>
        </button>
        <button
            class="dg-btn dg-btn--ok dg-pull-right"
            @click.stop.prevent="handleProceed()"
        >
            <span class="dg-btn-content">
                <span v-if="options.href">Изменить</span>
                <span v-else>Добавить</span>
            </span>
        </button>
        <div class="dg-clear" />
    </div>
</template>

<script>
    import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';

    export default {
        mixins: [DialogMixin],
        data: function() {
            return {
                url: this.options.href || '',
                utm_source: this.options.utm_source,
                utm_medium: this.options.utm_medium,
                utm_campaign: this.options.utm_campaign || '<ID рассылки>',
                utm_content: this.options.utm_content,
                urlError: '',
                valid: true,
            }
        },
        methods: {
            updateURL: function(value, valid) {
                this.url = value;
                this.valid = valid;
                if (valid) {
                    this.urlError = '';
                }
            },
            handleProceed: function() {
                if (!this.valid) {
                    this.urlError = 'Неправильный формат URL';
                    return;
                }
                this.proceed(this.url);
            },
            handleDismiss() {
                this.proceed(null);
            }
        }
    }
</script>
